import {Application} from '../types';

// FNP-1234: has this application ever been provisioned?
//
// The Decommission button asks this to decide whether to offer a teardown at
// all, and it used to ask `businessDomain` — a field that stands in for the
// question without answering it.
//
// That inference held only while `createApplication` both created the record
// and provisioned it. FNP-1013 split those apart, and `businessDomain` moved
// with the split: it is a PROVISIONING INPUT on `provisionApplication`, not a
// property of the record. The schema says so directly — "PROVISIONING INPUTS,
// not properties of the record" — and it is optional there, an override for
// records that happen to carry one.
//
// So an application provisioned through the new mutation owns a stack, a
// bucket, two repos and two pipelines while its record has no `businessDomain`
// at all. Every such application was undecommissionable from the console:
// `fnp1231-canary`, which prompted this, and `fnp1013-provision-test`, stranded
// since FNP-1013's own verification run (FNP-1235).
//
// ⚠️ THE STACK NAME IS THE ANSWER BECAUSE SOMETHING WRITES IT.
//
// `infraStackNames` is written by the orchestrator's ProvisionInfraPipeline
// step, and it is what the SERVER-side gate reads to pick a delete target
// (console-api's validate-deprovisionable.ts). Gating the button on the same
// fact the server gates on means the UI and the API can no longer disagree
// about whether an application is a teardown candidate.
//
// ⚠️ ANY stage, not the console's own. The repos and pipelines are SHARED
// across stages, so a teardown is application-level (FNP-1014) and a record
// with a stack in any stage owns real infrastructure. `getDecommissionEligibility`
// still refuses per-stage when the CURRENT stage has no stack name, and that
// refusal is the one the operator reads — this predicate only decides whether
// the button exists to be refused. Deliberately the wider test of the two: a
// button that refuses with a reason beats a button that is not there.
export function hasProvisionedInfrastructure(record: Application): boolean {
    const stackNames = record.infraStackNames;
    if (!stackNames) return false;
    return (['dev', 'test', 'prod'] as const)
        .some((stage) => (stackNames[stage] ?? '') !== '');
}
